import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { featuredOffers, gameOffers, categories, vpnOffers, surveyOffers, appOffers,  giftCardOffers } from '../data/offers';
import OfferCard from '../components/OfferCard';
import { ArrowLeft } from 'lucide-react';

const Category = () => {
  const { id } = useParams();
  const category = categories.find(c => c.id === id);
  
  // Combine all offers by category
  const allOffers = [
    ...featuredOffers,
    ...gameOffers,
    ...vpnOffers,
    ...surveyOffers,
    ...appOffers,
    ...giftCardOffers
  ];

  // Filter based on category
  let filtered = [];
  
  if (id === 'hot' || id === 'trending') {
    filtered = allOffers.filter(o => o.badgeType === 'HOT' || o.badgeType === 'NEW');
  } else if (id === 'games') {
    filtered = gameOffers;
  } else if (id === 'vpns') {
    filtered = vpnOffers;
  } else if (id === 'rewards') {
    filtered = surveyOffers;
  } else if (id === 'apps') {
    filtered = appOffers;
  } else if (id === 'gift-cards') {
    filtered = giftCardOffers;
  } else {
    filtered = allOffers.filter(o => o.category && o.category.toLowerCase() === id?.toLowerCase());
  }

  const displayOffers = filtered.length > 0 ? filtered : allOffers.slice(0, 8);
  const Icon = category && category.icon;

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 px-4 py-6  max-w-full mx-auto">
      <div className="flex flex-row items-center justify-between gap-4 mb-8">
        <Link to="/" className="p-2 -ml-2 text-gray-400 hover:text-white">
          <ArrowLeft className="w-6 h-6" />
        </Link>
        <div className="flex items-center gap-2">
           {Icon ? (
             <span className="text-3xl md:text-4xl"><Icon className="w-8 h-8" /></span>
           ) : (
             <span className="text-3xl md:text-4xl">📦</span>
           )}
           <h1 className="text-2xl font-bold capitalize">{id?.replace(/-/g, ' ')}</h1>
        </div>
        <div className="w-10" /> {/* Spacer */}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {displayOffers.map((offer) => (
          <OfferCard key={offer.id} offer={offer} />
        ))}
      </div>

      {displayOffers.length === 0 && (
        <div className="text-center py-20 text-gray-500">
          <p>No offers found in this category yet.</p>
          <p className="text-sm mt-2">Check back later or browse Trending!</p>
        </div>
      )}
    </div>
  );
};

export default Category;
